module.exports = __webpack_public_path__ + "static/media/loc6_img14.c5c12e2d.jpg";